import validate from "C:/temporary/iqa/iQA_FRONT/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "C:/temporary/iqa/iQA_FRONT/middleware/auth.global.ts";
import order_45header_45global from "C:/temporary/iqa/iQA_FRONT/middleware/order-header.global.ts";
import save_45route_45global from "C:/temporary/iqa/iQA_FRONT/middleware/save-route.global.ts";
import manifest_45route_45rule from "C:/temporary/iqa/iQA_FRONT/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  order_45header_45global,
  save_45route_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}